/**
 * Mercadão PDP — galeria + barra flutuante (ES5).
 * Variante ativa = combinação dos radios (cor + tamanho), não o JSON atrasado do picker.
 */
(function () {
  'use strict';

  var state = {
    lastVariantId: null,
    lastGalleryKey: null,
    changeGeneration: 0,
  };

  function norm(value) {
    if (value == null) return null;
    return String(value).trim();
  }

  function parseJson(el) {
    if (!el || !el.textContent) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function getPdpRoot() {
    return document.querySelector('[data-md-pdp]');
  }

  function getPicker() {
    var root = getPdpRoot();
    return root ? root.querySelector('variant-picker.mercadao-pdp-variant-picker') : null;
  }

  function parseMap(root) {
    return parseJson(root.querySelector('[data-md-gallery-variant-map]'));
  }

  function parseAllVariants(root) {
    var map = parseMap(root || getPdpRoot());
    if (map && map.allVariants && map.allVariants.length) return map.allVariants;

    var scope = root || getPdpRoot();
    var el = scope ? scope.querySelector('[data-md-all-variants]') : null;
    if (!el) el = document.querySelector('[data-md-all-variants]');
    return parseJson(el) || [];
  }

  function getPickerVariantFromScript() {
    var picker = getPicker();
    if (!picker) return null;
    return parseJson(picker.querySelector('script[type="application/json"]'));
  }

  function matchVariantFromSelections(allVariants, picker) {
    if (!allVariants || !allVariants.length || !picker) return null;

    var selections = {};
    var fieldsets = picker.querySelectorAll('fieldset');

    for (var i = 0; i < fieldsets.length; i += 1) {
      var checked = fieldsets[i].querySelector('input[type="radio"]:checked');
      if (!checked) continue;

      var pos = Number(checked.dataset.inputId ? checked.dataset.inputId.split('-')[0] : 0);
      if (!pos) continue;
      selections[String(pos)] = norm(checked.value);
    }

    var keys = Object.keys(selections);
    if (!keys.length) return null;

    var match = null;
    var matchCount = 0;

    for (var j = 0; j < allVariants.length; j += 1) {
      var v = allVariants[j];
      var ok = true;

      for (var k = 0; k < keys.length; k += 1) {
        var p = Number(keys[k]);
        var sel = selections[keys[k]];

        if (p === 1 && norm(v.option1) !== sel) ok = false;
        else if (p === 2 && norm(v.option2) !== sel) ok = false;
        else if (p === 3 && norm(v.option3) !== sel) ok = false;
      }

      if (ok) {
        match = v;
        matchCount += 1;
        if (matchCount > 1 && keys.length === fieldsets.length) {
          /* várias variantes com mesma combinação parcial — continua */
        }
      }
    }

    return match;
  }

  function mergeVariant(base, extra) {
    if (!base) return extra;
    if (!extra) return base;
    if (String(base.id) !== String(extra.id)) return base;
    var merged = {};
    var key;
    for (key in base) {
      if (Object.prototype.hasOwnProperty.call(base, key)) merged[key] = base[key];
    }
    for (key in extra) {
      if (Object.prototype.hasOwnProperty.call(extra, key)) merged[key] = extra[key];
    }
    return merged;
  }

  function resolveActiveVariant(root) {
    var picker = getPicker();
    var allVariants = parseAllVariants(root);
    var fromSelection = matchVariantFromSelections(allVariants, picker);
    var fromScript = getPickerVariantFromScript();

    /* Sempre prioriza cor+tamanho dos radios — o JSON do picker traz só a opção clicada */
    if (fromSelection && fromSelection.id) {
      if (fromScript && String(fromScript.id) === String(fromSelection.id)) {
        return mergeVariant(fromSelection, fromScript);
      }
      return fromSelection;
    }

    if (fromScript && fromScript.id) return fromScript;
    return null;
  }

  function applyResolvedVariant(root, map) {
    var variant = resolveActiveVariant(root);
    if (variant && variant.id) {
      onVariantResolved(root, map, variant);
      return true;
    }
    return false;
  }

  function syncVariantInput(variantId) {
    if (!variantId) return;
    var input =
      document.querySelector('product-form-component input[name="id"]') ||
      document.querySelector('[data-md-product-form] input[name="id"]') ||
      document.querySelector('.section-mercadao-product input[name="id"]');
    if (input) input.value = String(variantId);
  }

  function firstImageSrc(map, imageIds) {
    if (!map || !map.images || !imageIds || !imageIds.length) return null;
    var data = map.images[String(imageIds[0])];
    return data && data.src900 ? data.src900 : null;
  }

  function featuredImageId(variant) {
    if (!variant) return null;
    if (variant.featured_media && variant.featured_media.id != null) return String(variant.featured_media.id);
    if (variant.featured_image && variant.featured_image.id != null) return String(variant.featured_image.id);
    return null;
  }

  function resolveVisualGroupValue(root, map) {
    if (!map) return null;
    var picker = getPicker();
    if (picker) {
      var visualFieldset = picker.querySelector('[data-md-visual-option="true"]');
      if (visualFieldset) {
        var visualChecked = visualFieldset.querySelector('input[type="radio"]:checked');
        if (visualChecked) return norm(visualChecked.value);
      }
    }

    var visualKey = map.visualOption || 'option1';
    var pos = visualKey === 'option2' ? 2 : visualKey === 'option3' ? 3 : 1;
    if (!picker) return null;

    var fieldsets = picker.querySelectorAll('fieldset');
    for (var i = 0; i < fieldsets.length; i += 1) {
      var checked = fieldsets[i].querySelector('input[type="radio"]:checked');
      if (!checked) continue;
      var inputPos = Number(checked.dataset.inputId ? checked.dataset.inputId.split('-')[0] : 0);
      if (inputPos === pos) return norm(checked.value);
    }

    if (map.resolver && map.resolver.groupsOrdered && map.resolver.groupsOrdered.length === 1) {
      return norm(map.resolver.groupsOrdered[0]);
    }
    return null;
  }

  function computeGalleryIds(map, groupValue, variant) {
    if (!groupValue && variant && window.MercadaoPdpGallery) {
      groupValue = window.MercadaoPdpGallery.groupForVariant(variant, map.visualOption || 'option1');
    }
    if (!groupValue && map.resolver && map.resolver.groupsOrdered && map.resolver.groupsOrdered.length === 1) {
      groupValue = map.resolver.groupsOrdered[0];
    }
    if (window.MercadaoPdpGallery && map.resolver && groupValue) {
      var computed = window.MercadaoPdpGallery.computeForGroup(map, groupValue);
      if (computed && computed.length) return computed;
    }
    return null;
  }

  function reorderGalleryIds(map, ids, groupValue, variant) {
    if (
      !ids ||
      !ids.length ||
      !groupValue ||
      !window.MercadaoPdpGallery ||
      !window.MercadaoPdpGallery.orderGroupImageIds ||
      !map.resolver ||
      !map.resolver.images
    ) {
      return ids;
    }

    var include = {};
    var i;
    for (i = 0; i < ids.length; i += 1) include[String(ids[i])] = true;

    var feat = null;
    if (variant) {
      if (variant.featured_media && variant.featured_media.id != null) feat = variant.featured_media.id;
      else if (variant.featured_image && variant.featured_image.id != null) feat = variant.featured_image.id;
    }

    return (
      window.MercadaoPdpGallery.orderGroupImageIds(
        map.resolver.images,
        include,
        groupValue,
        map.allVariants || [],
        map.visualOption || map.resolver.visualOption || 'option1',
        feat
      ) || ids
    );
  }

  function imageIdsForVariant(map, variant, root) {
    if (!map) return null;

    var groupValue = resolveVisualGroupValue(root, map);
    if (!groupValue && variant && window.MercadaoPdpGallery) {
      groupValue = window.MercadaoPdpGallery.groupForVariant(variant, map.visualOption || 'option1');
    }
    if (!groupValue && variant) {
      var visualKey = map.visualOption || 'option1';
      if (variant[visualKey] != null) groupValue = norm(variant[visualKey]);
    }

    if (
      groupValue &&
      map.byVisual &&
      map.byVisual[groupValue] &&
      map.byVisual[groupValue].imageIds &&
      map.byVisual[groupValue].imageIds.length
    ) {
      return reorderGalleryIds(
        map,
        map.byVisual[groupValue].imageIds.map(String),
        groupValue,
        variant
      );
    }

    var computed = computeGalleryIds(map, groupValue, variant);
    if (computed && computed.length) {
      return reorderGalleryIds(map, computed, groupValue, variant);
    }

    if (!variant || !variant.id) return null;
    var variantId = String(variant.id);
    var entry = map.variants && map.variants[variantId];
    if (!entry) return null;

    var imageIds = entry.imageIds || entry.mediaIds || [];
    if (!imageIds || !imageIds.length) return null;
    return reorderGalleryIds(map, imageIds.map(String), groupValue, variant);
  }

  function gridImageIds(map, variant, root) {
    var all = imageIdsForVariant(map, variant, root);
    if (!all || !all.length) return null;
    var maxSlots = map.maxSlots || 4;
    return all.slice(0, maxSlots);
  }

  function stickyImageFromGallery(root) {
    var cellImg =
      root.querySelector('[data-md-gallery-cell] .md-pdp__gallery-cell-img') ||
      root.querySelector('.md-pdp__gallery-cell-img');
    return cellImg && cellImg.src ? cellImg.src : null;
  }

  function swatchSrcFromPicker() {
    var picker = getPicker();
    if (!picker) return null;
    var visualFieldset = picker.querySelector('[data-md-visual-option="true"]');
    var scope = visualFieldset || picker;
    var checked = scope.querySelector('input[type="radio"]:checked') || picker.querySelector('input[type="radio"]:checked');
    if (!checked) return null;
    var label = checked.closest('label');
    var swatchImg = label ? label.querySelector('.mercadao-color-swatch__img') : null;
    return swatchImg && swatchImg.src ? swatchImg.src : null;
  }

  function resolveStickyImageSrc(root, map, variant) {
    var src = null;

    if (variant && variant.id && map) {
      src = firstImageSrc(map, imageIdsForVariant(map, variant, root));
      if (src) return src;
    }

    src = swatchSrcFromPicker();
    if (src) return src;

    if (variant && variant.featured_image && variant.featured_image.src) {
      return variant.featured_image.src;
    }

    src = stickyImageFromGallery(root);
    if (src) return src;

    return null;
  }

  function formatMoney(cents, format) {
    var amount = (Number(cents) / 100).toFixed(2);
    var tpl = format || '{{amount}}';
    if (tpl.indexOf('{{amount}}') >= 0) return tpl.replace('{{amount}}', amount);
    if (tpl.indexOf('{{ amount }}') >= 0) return tpl.replace('{{ amount }}', amount);
    return 'R$ ' + amount.replace('.', ',');
  }

  function updateStickyPrice(root, variant) {
    var stickyPrice = document.querySelector('[data-md-sticky-price]');
    if (!stickyPrice) return;

    var pixEl = root.querySelector('[data-md-pix]');
    if (pixEl && pixEl.textContent && pixEl.textContent.trim()) {
      stickyPrice.textContent = pixEl.textContent;
      return;
    }

    if (!variant || variant.price == null) return;

    var pixPct = Number(root.dataset.pixDiscount || 5);
    var pixCents = Math.round(Number(variant.price) * (100 - pixPct) / 100);
    var tpl = root.dataset.pixTemplate || '';
    var money = formatMoney(pixCents, root.dataset.moneyFormat);
    stickyPrice.textContent = tpl.indexOf('__PRICE__') >= 0 ? tpl.replace('__PRICE__', money) : money;
  }

  function setStickyImage(src, variantId) {
    var img = document.querySelector('[data-md-sticky-image]');
    if (!img || !src) return;

    var id = variantId != null ? String(variantId) : '';
    var nextSrc = String(src);

    if (id && img.dataset.mdVariantId === id && img.getAttribute('src') === nextSrc) return;

    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.setAttribute('src', nextSrc);
    if (id) img.dataset.mdVariantId = id;
    img.removeAttribute('hidden');
  }

  function applyStickyState(root, map, variant) {
    if (!variant || !variant.id) return;

    var variantId = String(variant.id);
    syncVariantInput(variantId);
    updateGalleryForVariant(root, map, variant);
    setStickyImage(resolveStickyImageSrc(root, map, variant), variantId);
    updateStickyPrice(root, variant);

    var sticky = document.querySelector('mercadao-sticky-cart');
    if (!sticky) return;

    sticky.dataset.activeVariantId = variantId;
    state.lastVariantId = variantId;

    var btn = sticky.querySelector('[data-md-sticky-add]');
    var unavailable = variant.available === false;
    var soldOutLabel = sticky.dataset.labelSoldOut || 'Esgotado';
    var addLabel = sticky.dataset.labelAdd || 'Adicionar ao carrinho';
    if (btn) {
      btn.disabled = unavailable;
      btn.textContent = unavailable ? soldOutLabel : addLabel;
    }
    sticky.dataset.variantAvailable = unavailable ? 'false' : 'true';

    var buyNow = root.querySelector('[data-md-buy-now]');
    var addCart = root.querySelector('[data-md-add-cart]');
    var pdpSoldOut = root.dataset.labelSoldOut || soldOutLabel;
    var pdpBuyNow = root.dataset.labelBuyNow || 'Comprar agora';
    var pdpAddCart = root.dataset.labelAddCart || addLabel;
    if (buyNow) {
      buyNow.disabled = unavailable;
      buyNow.textContent = unavailable ? pdpSoldOut : pdpBuyNow;
    }
    if (addCart) {
      addCart.disabled = unavailable;
      addCart.textContent = unavailable ? pdpSoldOut : pdpAddCart;
    }
    var notify = root.querySelector('[data-md-notify]');
    if (notify) notify.classList.toggle('hidden', !unavailable);
    sticky.removeAttribute('hidden');
  }

  function renderGallery(root, map, gridIds, fullIds) {
    var grid = root.querySelector('[data-md-gallery-grid]');
    if (!grid || !map || !map.images || !gridIds || !gridIds.length) return;
    var maxSlots = map.maxSlots || Number(grid.dataset.slots) || 4;
    var totalImages = (fullIds && fullIds.length) || gridIds.length;
    var moreCount = Math.max(0, totalImages - maxSlots);
    var zoomLabel = root.dataset.galleryZoomLabel || 'Ampliar foto __INDEX__';
    var moreBadgeTpl = root.dataset.galleryMoreBadge || '+__COUNT__';
    grid.dataset.totalImages = String(totalImages);
    grid.innerHTML = '';

    for (var slot = 0; slot < maxSlots; slot += 1) {
      var id = gridIds[slot];
      var data = id != null ? map.images[String(id)] : null;
      if (data && data.src900) {
        var btn = document.createElement('button');
        btn.type = 'button';
        var isLastWithMore = slot === maxSlots - 1 && moreCount > 0;
        btn.className =
          'md-pdp__gallery-cell' + (isLastWithMore ? ' md-pdp__gallery-cell--has-more' : '');
        btn.setAttribute('role', 'listitem');
        btn.setAttribute('data-md-gallery-cell', '');
        btn.setAttribute('data-image-id', String(id));
        btn.setAttribute('aria-label', zoomLabel.replace('__INDEX__', String(slot + 1)));
        var img = document.createElement('img');
        img.className = 'md-pdp__gallery-cell-img';
        img.alt = data.alt || '';
        img.loading = slot === 0 ? 'eager' : 'lazy';
        img.removeAttribute('src');
        img.src = data.src900;
        img.sizes = '(min-width: 990px) 26vw, 46vw';
        btn.appendChild(img);
        if (isLastWithMore) {
          var badge = document.createElement('span');
          badge.className = 'md-pdp__gallery-cell-more';
          badge.setAttribute('aria-hidden', 'true');
          badge.textContent = moreBadgeTpl.replace('__COUNT__', String(moreCount));
          btn.appendChild(badge);
        }
        grid.appendChild(btn);
      } else {
        var empty = document.createElement('div');
        empty.className = 'md-pdp__gallery-cell md-pdp__gallery-cell--empty';
        empty.setAttribute('role', 'listitem');
        empty.setAttribute('aria-hidden', 'true');
        grid.appendChild(empty);
      }
    }
  }

  function updateGalleryForVariant(root, map, variant) {
    var fullIds = imageIdsForVariant(map, variant, root);
    if (!fullIds || !fullIds.length) return;
    var groupValue = resolveVisualGroupValue(root, map) || '';
    if (!groupValue && variant && window.MercadaoPdpGallery) {
      groupValue = window.MercadaoPdpGallery.groupForVariant(variant, map.visualOption || 'option1');
    }
    var galleryKey = groupValue + '|' + fullIds.join(',');
    if (state.lastGalleryKey === galleryKey) return;
    state.lastGalleryKey = galleryKey;
    var gridIds = fullIds.slice(0, map.maxSlots || 4);
    renderGallery(root, map, gridIds, fullIds);
  }

  function onVariantResolved(root, map, variant) {
    if (!variant || !variant.id) return;
    applyStickyState(root, map, variant);
  }

  function scheduleVariantSync(root, map) {
    state.changeGeneration += 1;
    var generation = state.changeGeneration;

    function attempt(retry) {
      if (generation !== state.changeGeneration) return;
      if (applyResolvedVariant(root, map)) return;
      if (retry < 24) {
        window.setTimeout(function () {
          attempt(retry + 1);
        }, retry < 6 ? 50 : 100);
      }
    }

    applyResolvedVariant(root, map);

    [0, 50, 120, 250, 400].forEach(function (delay) {
      window.setTimeout(function () {
        if (generation !== state.changeGeneration) return;
        applyResolvedVariant(root, map);
      }, delay);
    });

    window.setTimeout(function () {
      attempt(0);
    }, 80);
  }

  function stickyAddToCart() {
    var root = getPdpRoot();
    var variant = root ? resolveActiveVariant(root) : null;
    var variantId = variant && variant.id ? Number(variant.id) : null;

    if (!variantId) {
      var input =
        document.querySelector('[data-md-product-form] input[name="id"]') ||
        document.querySelector('product-form-component input[name="id"]');
      variantId = input && input.value ? Number(input.value) : null;
    }

    if (!variantId) return;

    syncVariantInput(variantId);

    var btn = document.querySelector('[data-md-sticky-add]');
    if (btn) {
      btn.classList.add('md-pdp__btn--busy');
      btn.setAttribute('aria-busy', 'true');
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart add failed');
        return res.json();
      })
      .then(function (cart) {
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: 'mercadao-sticky-cart',
              data: { source: 'product-form-component', variantId: String(variantId) },
            },
          })
        );
      })
      .catch(function () {
        var submitBtn =
          document.querySelector('[data-md-add-cart]') ||
          document.querySelector('[ref="addToCartButton"]');
        var form = submitBtn ? submitBtn.closest('form') : null;
        if (form && submitBtn) {
          if (typeof form.requestSubmit === 'function') form.requestSubmit(submitBtn);
          else submitBtn.click();
        }
      })
      .finally(function () {
        var v = root ? resolveActiveVariant(root) : null;
        var btnDone = document.querySelector('[data-md-sticky-add]');
        if (btnDone) {
          btnDone.classList.remove('md-pdp__btn--busy');
          btnDone.removeAttribute('aria-busy');
        }
        if (btnDone && sticky) {
          var unavail = v && v.available === false;
          var soldLbl = sticky.dataset.labelSoldOut || 'Esgotado';
          var addLbl = sticky.dataset.labelAdd || 'Adicionar ao carrinho';
          btnDone.disabled = unavail;
          btnDone.textContent = unavail ? soldLbl : addLbl;
        }
      });
  }

  function setupStickyBar() {
    var sticky = document.querySelector('mercadao-sticky-cart');
    var actions = document.querySelector('[data-md-pdp] .md-pdp__actions');
    var footer = document.querySelector('footer') || document.querySelector('[class*="footer-group"]');
    if (!sticky || !actions || !footer) return;

    var bar = sticky.querySelector('[data-md-sticky-bar]');
    if (!bar) return;

    var isStuck = false;
    var hiddenByFooter = false;

    function buttonsAbove() {
      var rect = actions.getBoundingClientRect();
      return rect.bottom < 0 || rect.top < 0;
    }

    function showBar() {
      isStuck = true;
      bar.dataset.stuck = 'true';
    }

    function hideBar() {
      isStuck = false;
      bar.dataset.stuck = 'false';
    }

    if (typeof IntersectionObserver === 'undefined') return;

    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      if (!entry) return;
      if (!entry.isIntersecting && !isStuck && buttonsAbove()) showBar();
      else if (entry.isIntersecting && isStuck) {
        hiddenByFooter = false;
        hideBar();
      }
    }).observe(actions);

    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      if (!entry) return;
      if (entry.isIntersecting && isStuck && buttonsAbove()) {
        hiddenByFooter = true;
        hideBar();
      } else if (!entry.isIntersecting && hiddenByFooter && buttonsAbove()) {
        hiddenByFooter = false;
        showBar();
      }
    }).observe(footer);

    var addBtn = sticky.querySelector('[data-md-sticky-add]');
    if (addBtn && !addBtn.dataset.mdStickyBound) {
      addBtn.dataset.mdStickyBound = 'true';
      addBtn.addEventListener('click', stickyAddToCart);
    }
  }

  function watchPickerJson(root, map) {
    var picker = getPicker();
    if (!picker || typeof MutationObserver === 'undefined') return;

    var script = picker.querySelector('script[type="application/json"]');
    if (!script) return;

    if (script._mdJsonObserver) {
      script._mdJsonObserver.disconnect();
      script._mdJsonObserver = null;
    }

    var observer = new MutationObserver(function () {
      applyResolvedVariant(root, map);
    });

    script._mdJsonObserver = observer;
    observer.observe(script, { characterData: true, childList: true, subtree: true });
  }

  function handleVariantEvent(root, map) {
    state.lastVariantId = null;
    state.lastGalleryKey = null;
    applyResolvedVariant(root, map);
    scheduleVariantSync(root, map);
  }

  function initRoot(root) {
    if (!root || root.dataset.mdPdpInit === 'true') return;
    var map = parseMap(root);
    if (!map) return;

    root.dataset.mdPdpInit = 'true';

    root.addEventListener('change', function (event) {
      var target = event.target;
      if (!target || target.type !== 'radio') return;
      if (!target.closest || !target.closest('variant-picker.mercadao-pdp-variant-picker')) return;

      state.lastVariantId = null;
      state.lastGalleryKey = null;
      applyResolvedVariant(root, map);
      updateGalleryForVariant(root, map, resolveActiveVariant(root));
      scheduleVariantSync(root, map);
    });

    var form = root.querySelector('[data-md-product-form]');
    if (form) {
      form.addEventListener('submit', function () {
        var variant = resolveActiveVariant(root);
        if (variant && variant.id) syncVariantInput(variant.id);
      });
    }

    document.addEventListener('variant:update', function (event) {
      var detail = event.detail;
      if (!detail) return;
      var productId = detail.data && detail.data.productId;
      if (productId && String(productId) !== String(root.dataset.productId)) return;
      /* Após morph do Horizon + product-form (input id errado do JSON parcial) */
      handleVariantEvent(root, map);
    });

    document.addEventListener('variant:selected', function () {
      state.lastVariantId = null;
      scheduleVariantSync(root, map);
    });

    watchPickerJson(root, map);

    var initial = resolveActiveVariant(root);
    state.lastGalleryKey = null;
    if (initial && initial.id) {
      onVariantResolved(root, map, initial);
    } else {
      updateGalleryForVariant(root, map, initial);
    }
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-md-pdp]');
    for (var i = 0; i < nodes.length; i += 1) initRoot(nodes[i]);
    setupStickyBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    var root = event.target.querySelector ? event.target.querySelector('[data-md-pdp]') : null;
    if (root) initRoot(root);
    setupStickyBar();
  });
})();
